import { styled } from '@mui/material';
import { IconButton } from 'components/IconButton';

export const StyledGoalItemLabelWrap = styled('div')({
	display: 'flex',
	alignItems: 'flex-start',
	gap: '4px',

	'&:hover': {
		'& button': {
			opacity: 1,
			visibility: 'visible',
			width: 'auto',
		},
	},
});

export const StyledGoalItemLabelCloseButton = styled(IconButton)({
	padding: '0',
	visibility: 'hidden',
	opacity: 0,
	width: 0,
	overflow: 'hidden',
	transition: 'width 0s 0s, opacity 0.3s 0s linear',
});
